import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer
      data-testid="site-footer"
      className="mt-20"
      style={{ backgroundColor: "#2A2624" }}
    >
      <div className="mx-auto flex max-w-[1440px] flex-col gap-5 px-6 py-8 text-sm sm:px-10 lg:px-20">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <p
            className="text-sm text-white/60"
            style={{ fontWeight: 400, letterSpacing: "0.3px" }}
          >
            © {new Date().getFullYear()} — {t("rights")} | Teilweise KI-unterstützte Inhalte
          </p>
          <nav className="flex flex-wrap items-center gap-x-8 gap-y-2">
            <Link
              to="/impressum"
              data-testid="footer-link-impressum"
              className="text-white transition-colors duration-200 hover:text-white/70"
              style={{ fontWeight: 500, letterSpacing: "0.3px" }}
            >
              {t("impressum")}
            </Link>
            <Link
              to="/datenschutz"
              data-testid="footer-link-datenschutz"
              className="text-white transition-colors duration-200 hover:text-white/70"
              style={{ fontWeight: 500, letterSpacing: "0.3px" }}
            >
              {t("datenschutz")}
            </Link>
            <Link
              to="/kontakt"
              data-testid="footer-link-kontakt"
              className="text-white transition-colors duration-200 hover:text-white/70"
              style={{ fontWeight: 500, letterSpacing: "0.3px" }}
            >
              {t("kontakt")}
            </Link>
          </nav>
        </div>
        <p
          data-testid="footer-social-seller-info"
          className="text-center text-xs text-white/45 sm:text-left"
          style={{ fontWeight: 400, letterSpacing: "0.3px" }}
        >
          Infos & Tools für Social Seller{" "}
          <a
            href="https://socialseller.info"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-social-seller-link"
            className="text-white/70 underline decoration-white/30 underline-offset-2 transition-colors duration-200 hover:text-white"
          >
            hier
          </a>
        </p>
        <p
          data-testid="footer-powered-by"
          className="text-center text-xs text-white/40 sm:text-left"
          style={{ fontWeight: 400, letterSpacing: "0.3px" }}
        >
          Webseite powered by{" "}
          <a
            href="https://live-your-visions.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-powered-by-link"
            className="text-white/70 underline decoration-white/30 underline-offset-2 transition-colors duration-200 hover:text-white"
          >
            live-your-visions.com
          </a>
        </p>
      </div>
    </footer>
  );
}
